import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SummerInternshipsHeadingListComponent } from './summer-internships-heading-list/summer-internships-heading-list.component';
import { SummerInternshipsHeadingCreateComponent } from './summer-internships-heading-create/summer-internships-heading-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: SummerInternshipsHeadingListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: SummerInternshipsHeadingCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'summer-internships-heading-create/:id',
        component: SummerInternshipsHeadingCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SummerInternshipsHeadingRoutingModule { }
